<template>
  <el-popover placement="right" trigger="click" width="250" v-model="show">
    <div class="medication-info">
      <p>
        <strong>用药周期：</strong>
        <el-select size="mini" v-model="model.Drug_Days" placeholder="请选择" style="width: 150px;">
          <el-option v-for="item in drugDaysOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>用药方式：</strong>
        <el-select size="mini" v-model="model.Drug_UseMethod" placeholder="请选择" style="width: 150px;">
          <el-option v-for="item in drugUseMethodOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>用药频次：</strong>
        <el-select size="mini" v-model="model.Drug_CountPerDay" placeholder="请选择" style="width: 150px;">
          <el-option v-for="item in drugCountPerDayOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>用药规律：</strong>
        <el-select size="mini" v-model="model.Drug_TimeInDay" placeholder="请选择" style="width: 150px;">
          <el-option v-for="item in drugTimeInDayOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>眼别：</strong>
        <el-select size="mini" v-model="model.LeftOrRight" placeholder="请选择" style="width: 150px;">
          <el-option v-for="item in eyeSelectOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>每次用量：</strong>
        <el-select size="mini" v-model="model.Drug_CountPerTime" placeholder="请选择" style="width: 150px;">
          <el-option v-for="item in drugCountPerTimeOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
      </p>
      <!-- 确认取消按钮 -->
      <div class="btn-wrapper">
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="mini" :loading="loading" @click="handleClick">确认</el-button>
      </div>
    </div>
    <el-button slot="reference" type="text">用药详情</el-button>
  </el-popover>
</template>
<script>
import { eyeSelectOptions, drugCountPerTimeOptions, drugTimeInDayOptions, drugCountPerDayOptions, drugUseMethodOptions, drugDaysOptions } from '../data/select-options';
import { updateCartProductApi } from '../api'
export default {
  name: 'MedicationPopover',
  inject: ['chooseId'],
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    productId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      eyeSelectOptions,
      drugCountPerTimeOptions,
      drugTimeInDayOptions,
      drugCountPerDayOptions,
      drugUseMethodOptions,
      drugDaysOptions,
      show: false,
      loading: false,
      medicationList: [
        {
          id: 1,
          name: '阿司匹林',
          spec: '0.5g/片',
          usage: '口服',
          note: '请勿 overdose'
        },
        {
          id: 2,
          name: '阿司匹林',
          spec: '0.5g/片',
          usage: '口服',
          note: '请勿 overdose'
        }
      ]
    }
  },
  methods: {
    conversionJson(json) {
      if (!json) {
        return "";
      }
      let str = JSON.stringify(json);
      str = str.replace(/"/g, "***");
      return str;
    },
    async handleClick() {
      if (!this.chooseId || !this.productId) return;
      try {
        this.loading = true;
        await updateCartProductApi({
          CHPPrescriptionData: this.conversionJson(this.model),
          CHPChooseId: this.chooseId,
          CHPProductId: this.productId,
          CHPStatus: 1
        })
        this.show = false;
        this.$emit('success', this.model);
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false;
      }
    },
    handleCancel() {
      this.show = false;
    }
  }
}
</script>
<style scoped lang="scss">
.medication-info {
  p {
    margin: 10px 0;

    strong {
      width: 70px;
      display: inline-block;
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: flex-end;
  }
}
</style>